import {Body1, Body2, Caption2, Subhead2, Title} from "../../../../../components/Font";
import React, {useEffect, useState} from "react";
import {Content, ContentXs, FlexColumnCentered, IconContainer} from "../../../../../components/ui/Content";
import {useTranslation} from "react-i18next";
import {Attendance, Close, GreenCircleCheck, NewClear} from "../../../../../icon/Icon";
import {InputWithSearchBox} from "../../../../../ui/Input/inputWithSearchBox";
import {
    Authorization,
    clearAndExit,
    ContinueConnectionAdmin,
    GetPerson,
    GetPersons,
    loginAdminExit,
    Replace,
    SignIn,
    clearSecondFactor,
} from "../../../slice";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {ButtonPrimary} from "../../../../../components/ui/Button";
import {IPerson} from "../../../../../interface/Auth/backend";
import {
    AccountSelectBlock,
    Border,
    BoxIsolatedContentAdmin,
    InputIconContainer,
    LoginAdminAccount,
    LoginAdminEmail,
    LoginAdminHeader,
    LoginAdminInfo,
    Padding24Width100,
    SelectedUserBlock,
    SelectedUserContent
} from "./style";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../../../ui/Loader/MiniLoader";
import {useTheme} from "styled-components";
import { TwoFactorConfirmation } from "../TwoFactorConfirmation";

interface User {
    id: string | null
    fio: string
    email: string
}

const defaultUser: User = {
    id: null,
    fio: '',
    email: ''
};

export const LoginFormAdmin = () => {
    const dispatch = useAppDispatch()
    const {t} = useTranslation();
    const {
        loginAdminToken,
        loginAdminEmail,
        loginAdminPersons,
        isFetching,
        loginAdminSuccess,
        isTryingAsAdmin,
        accounts,
        isFetchingInAuth,
        isAuthFetching,
    } = useAppSelector(state => state.auth)
    const Theme = useTheme()
    const secondFactor = useAppSelector(state => state.auth.secondFactor)
    const token = useAppSelector(state => state.auth.connection.token)
    const totalTTL = useAppSelector(state => state.auth.secondFactorTotalTtlMinutes)

    const [inputUser, setInputUser] = useState<User>(defaultUser);
    const [selectedUser, setSelectedUser] = useState<IPerson | null>(null)

    useEffect(() => {
        if (loginAdminToken && isTryingAsAdmin && loginAdminEmail) {
            dispatch(GetPerson({login: loginAdminEmail, loginAdminToken}))
        }
    }, []);

    useEffect(() => {
        if (loginAdminSuccess && loginAdminToken) {
            const urlSearch = new URLSearchParams(window.location.search)
            const client_id = urlSearch.get('client_id')
            if (client_id) {
                dispatch(Authorization(loginAdminToken))
            } else {
                dispatch(SignIn(loginAdminToken))
            }
        }
    }, [loginAdminSuccess]);

    const clearAndBack = () => {
        dispatch(clearAndExit());
        dispatch(loginAdminExit())

    }

    useEffect(() => {
        if (!isTryingAsAdmin && accounts.length === 1) {
            const account = accounts[0];
            localStorage.removeItem('userLogin')
            if (loginAdminToken) {
                dispatch(Replace({
                    token: loginAdminToken,
                    id: account.ad_person_id
                }))
            }
        }
    }, [accounts])

    const signInByAdmin = () => {
        if (!loginAdminToken) {
            return
        }

        if (isTryingAsAdmin) {
            if (selectedUser && selectedUser.id) {
                dispatch(ContinueConnectionAdmin({
                    token: loginAdminToken,
                    id: selectedUser.id
                }))
                setInputUser(defaultUser)
                setSelectedUser(null)
            }
            return
        }

        if (selectedUser && selectedUser.id) {
            dispatch(Replace({
                token: loginAdminToken,
                id: Number(selectedUser.id)
            }))
        }
    }

    if (secondFactor?.operationId && token) {
        const handle2FASuccess = () => {
            dispatch(clearSecondFactor())
        }
        return (
            <>
                <FlexColumnCentered className={'box-isolated'}>
                    <Title>Подтвердите вход</Title>
                    <BoxIsolatedContentAdmin>
                        <Caption2>На ваш номер отправлен код подтверждения. Введите его, чтобы продолжить.</Caption2>
                    </BoxIsolatedContentAdmin>
                </FlexColumnCentered>
                <TwoFactorConfirmation
                    operationId={secondFactor.operationId}
                    token={token}
                    isAdmin={true}
                    totalTTLMinutes={totalTTL ?? undefined}
                    onClose={() => {
                        dispatch(clearSecondFactor())
                        dispatch(clearAndExit())
                        dispatch(loginAdminExit())
                    }}
                    onSuccess={handle2FASuccess}
                    onAdminSuccess={handle2FASuccess}
                    onError={() => null}
                />
            </>
        )
    }

    return (
        <FlexColumnCentered className={'box-isolated'}>
            <BoxIsolatedContentAdmin>
                <LoginAdminHeader>
                    <Title>{t('auth.logInAccount')}</Title>
                    <span
                        onClick={() => clearAndBack()}
                        style={{marginLeft: '85px', cursor: 'pointer'}}
                    >
                        <Close/>
                    </span>
                </LoginAdminHeader>
                {isTryingAsAdmin && <LoginAdminInfo>
                    <Attendance/>
                    <Body2 color={'#007AFF'}>
                        Режим Администратора
                    </Body2>
                </LoginAdminInfo>}
                {
                    loginAdminEmail && <>
                        <LoginAdminAccount>
                            <Subhead2 style={{textAlign: 'start'}}>
                                Ваша учетная запись
                            </Subhead2>
                            <Caption2 style={{textAlign: 'start'}}>
                                Вы вошли под учетной записью:
                            </Caption2>
                        </LoginAdminAccount>
                        <LoginAdminEmail>
                            <Body2>
                                {loginAdminEmail}
                            </Body2>
                            {isTryingAsAdmin || (!isTryingAsAdmin && accounts.length > 1) && <Body1
                                style={{cursor: 'pointer'}}
                                onClick={() => clearAndBack()}
                                color={'#007AFF'}
                            >
                                Выйти
                            </Body1>}
                        </LoginAdminEmail>
                    </>
                }
                <Border/>
                {isTryingAsAdmin || (!isTryingAsAdmin && accounts.length > 1) && <Content style={{padding: '0 24px'}}>
                    <Subhead2 style={{textAlign: 'start'}}>
                        {t('auth.LoginUnderUserAccount')}
                    </Subhead2>
                    <ContentXs>
                        <Caption2 style={{textAlign: 'start'}}>
                            {isTryingAsAdmin ?
                                'В режиме Администратора вам доступен вход под учетной записью любого пользователя. Для этого введите ФИО или электронную почту нужного пользователя в поле ниже:' :
                                t('auth.selectAccountsMessage')}
                        </Caption2>
                    </ContentXs>
                </Content>}
                <Padding24Width100>
                    {
                        isTryingAsAdmin && <>
                            {
                                selectedUser
                                    ?
                                    <SelectedUserBlock>
                                        <SelectedUserContent>
                                            <div>
                                                {inputUser.fio}
                                            </div>
                                            <div>
                                                {inputUser.email}
                                            </div>
                                        </SelectedUserContent>
                                        <InputIconContainer
                                            onClick={() => setSelectedUser(null)}
                                        >
                                            <NewClear/>
                                        </InputIconContainer>
                                    </SelectedUserBlock>
                                    :
                                    <InputWithSearchBox
                                        isFetching={isFetching}
                                        job={true}
                                        placeholder="Введите имя или email пользователя"
                                        clear={() => {
                                            setInputUser({
                                                id: null,
                                                fio: '',
                                                email: ''
                                            });
                                            setSelectedUser(null)
                                        }}
                                        value={inputUser.fio}
                                        minLength={2}
                                        maxLength={255}
                                        required
                                        searchable
                                        data={loginAdminPersons.map((item) => ({
                                            id: item.id,
                                            title: item.fio,
                                            subtitle: item.email
                                        }))}
                                        onClick={(item) => {
                                            const selected = loginAdminPersons.find((i) => i.id === item.id);
                                            if (selected) {
                                                setInputUser(selected);
                                                setSelectedUser(selected)
                                            }
                                        }}
                                        onChange={(value) => {
                                            setInputUser({
                                                ...inputUser,
                                                fio: value,
                                            });
                                            if (value.length > 1) {
                                                dispatch(GetPersons({
                                                    login: value,
                                                    loginAdminToken: loginAdminToken as string
                                                }));
                                            }
                                        }}
                                    />
                            }
                        </>
                    }
                    {
                        (!isTryingAsAdmin && accounts.length > 1) && <>
                            {
                                accounts.map((account) => <AccountSelectBlock key={account.ad_person_id}
                                                                              onClick={() => selectedUser?.id === account.ad_person_id.toString() ? setSelectedUser(null) : setSelectedUser({
                                                                                  id: account.ad_person_id.toString(),
                                                                                  fio: account.fio,
                                                                                  email: account.email
                                                                              })}
                                >
                                    <InputIconContainer style={{marginLeft: '10px'}}>
                                        {selectedUser?.id === account.ad_person_id.toString() && <IconContainer>
                                            <GreenCircleCheck/>
                                        </IconContainer>}
                                    </InputIconContainer>
                                    <SelectedUserContent
                                        style={{marginLeft: (selectedUser?.id === account.ad_person_id.toString()) ? '-20px' : '-50px'}}>
                                        <div>
                                            {account.fio}
                                        </div>
                                        <div>
                                            {account.email}
                                        </div>
                                    </SelectedUserContent>

                                </AccountSelectBlock>)
                            }
                        </>
                    }
                </Padding24Width100>
                <Padding24Width100>
                    {(isFetchingInAuth || isAuthFetching)
                        ? <ButtonPrimary>
                            <LoaderContainer>
                                <MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small}/>
                            </LoaderContainer>
                        </ButtonPrimary>
                        : <ButtonPrimary
                            disabled={!selectedUser}
                            style={{height: '56px'}}
                            onClick={signInByAdmin}
                        >
                            Войти
                        </ButtonPrimary>}
                </Padding24Width100>
            </BoxIsolatedContentAdmin>
        </FlexColumnCentered>
    )
}

